import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCepMask]',
})
export class CepMaskDirective {
  private previousValue = null;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    setTimeout(() => this.setMask(), 0);
  }

  @HostListener('input')
  setMask() {
    const mask = this.createMask(this.el.nativeElement.value);
    if (this.el.nativeElement.value !== this.previousValue) {
      this.el.nativeElement.value = mask;
      this.previousValue = mask;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  createMask(cpf) {
    let newVal = cpf.replace(/\D/g, '');
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 5) {
      newVal = newVal.replace(/^(\d{0,5})/, '$1');
    } else if (newVal.length <= 9) {
      newVal = newVal.replace(/^(\d{0,5})(.*)/, '$1-$2');
    }
    return newVal;
  }
}
